import { Event } from "event-system";
import { ArrayOr, Assets, UnresolvedAsset, UnresolvedAssetObject } from "pixi.js";

export class BundleResourcesLoader {
    private readonly bundleName: string;
    private loadedBundle: any;
    private loaded: boolean;
    public get isLoaded(): boolean {
        return this.loaded;
    }
    public readonly onProgress: Event<number>;

    public constructor(bundleName: string) {
        this.bundleName = bundleName;
        this.loaded = false;
        this.onProgress = new Event<number>();
    }

    public getResource<T>(name: string): T {
        return this.loadedBundle[name] as T;
    }

    public updateBundle(assets: UnresolvedAsset[] | Record<string, ArrayOr<string> | UnresolvedAssetObject>): void {
        Assets.addBundle(this.bundleName, assets);
    }

    public async load(): Promise<BundleResourcesLoader> {
        if (this.bundleName == null) {
            throw new Error("Unable to load unnamed bundle");
        }
        if (this.loaded) {
            return this;
        }
        this.loadedBundle = await Assets.loadBundle(
            this.bundleName,
            (progress: number) => this.onProgress.emit(progress)
        );
        this.loaded = true;
        return this;
    }

    public destroy(): void {
        this.loaded = false;
        Assets.unloadBundle(this.bundleName);
    }
}
